import { groupBy } from "@osgfe/tools";

/* 根据当前页面的路径，从给定的菜单列表中找到对应的活动菜单项 */
export const getActiveMenu = (menuList) => {
  const activeItem = {
    defaultActive: "",
    defaultExpandedNames: [],
  };
  const { pathname } = window.location;
  const path = pathname.replace(".html", "");
  if (path === "/") return activeItem;
  menuList.forEach((firstMenu) => {
    if (firstMenu.url && firstMenu.url === path) {
      activeItem.defaultActive = firstMenu.id;
      activeItem.defaultExpandedNames.push(firstMenu.id);
    }
    if (firstMenu.children) {
      firstMenu.children.forEach((secondMenu) => {
        if (secondMenu.url === pathname) {
          activeItem.defaultActive = secondMenu.id;
          activeItem.defaultExpandedNames.push(firstMenu.id);
        }
      });
    }
  });
  return activeItem;
};

// 处理vss商品供应商侧边菜单列表
export const formatMenuSource = (menuList) => {
  /**
   * 获取菜单。
   * 这菜单数据是铺平的，层级关系看 parentId。
   * parent = -1 的就是一级菜单项，有且只有两级。
   */
  menuList.forEach((item) => {
    // 初始化
    item.badge = 0;
    item.visible = true;
  });

  /**
   * 将平铺的菜单项转换成树结构。
   * 先以 parent 为键给所有菜单项分类。
   * parent 为 -1 的项就是一级菜单，非 -1 的项就是子菜单，子菜单的 parent 就是一级菜单的 id
   */
  const _groupByParent = groupBy(menuList, "parent");

  let menuData = [];
  menuData = (_groupByParent[-1] || []).map((item) => {
    item.children = _groupByParent[item.id] || [];
    /** 现在本地手动处理url，上线稳定后修改远程配置后删除相关逻辑代码 */
    item.children = item.children.map((child) => {
      const { url } = child;
      let newUrl = "";
      if (url.startsWith("/micro")) {
        newUrl = url.replace("/micro", "");
      } else {
        newUrl = `/partner${url}`;
      }
      /** 二级（末级菜单）菜单结构 */
      return {
        ...child,
        id: `${child.id}`,
        level: 2,
        parentId: child.parent,
        /** 默认设置菜单打开方式 */
        type: 1,
        target: "_self",
        text: child.textMultiLocale,
        title: child.textMultiLocale,
        url: `${newUrl}.html`,
      };
    });
    return {
      ...item,
      url: item.url ? `/partner${item.url}.html` : "",
      id: `${item.id}`,
      position: "left",
      target: "_self",
      text: item.textMultiLocale,
      title: item.textMultiLocale,
    };
  });

  return menuData;
};

/** renxiao侧的菜单结构与商品不一样
 * 单独提供给renxiao侧使用的菜单处理方法
 */
export const formatRenxiaoMenuSource = (menuList) => {
  let formattedData = menuList || [];
  formattedData.forEach((v, index) => {
    let _url = "";
    if (v.url?.startsWith("/micro")) {
      _url = v.url.replace("/micro", "");
    } else {
      _url = `/partner${v.url}.html`;
    }
    v.id = index + 1;
    v.title = v.text;
    v.url = _url;
    v.target = "_self";
    v.position = "left";
    if (Array.isArray(v.children) && v.children.length) {
      v.children.forEach((s, sindex) => {
        let newUrl = "";
        const { url } = s;
        if (url.startsWith("/micro")) {
          newUrl = url.replace("/micro", "");
        } else {
          newUrl = `/partner${url}`;
        }
        s.id = `${index + 1}` + "children" + `${sindex + 1}`;
        s.title = s.text;
        s.url = `${newUrl}.html`;
        s.target = "_self";
        s.position = "left";
      });
    }
  });
  return formattedData;
};

function longestCommonSubUrlstring(str1, str2) {
  let maxLen = 0; // 最长公共子串的长度
  let endIndex = 0; // 最长公共子串的结束位置
  const dp = Array.from({ length: str1.length + 1 }, () =>
    Array(str2.length + 1).fill(0)
  );

  for (let i = 1; i <= str1.length; i++) {
    for (let j = 1; j <= str2.length; j++) {
      if (str1[i - 1] === str2[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1] + 1;
        if (dp[i][j] > maxLen) {
          maxLen = dp[i][j];
          endIndex = i;
        }
      }
    }
  }

  return str1.substring(endIndex - maxLen, endIndex);
}

export function findBestMatchUrl(targetUrl, menuList) {
  let bestMatch = null;
  let maxCommonLength = 0;

  menuList.forEach((item) => {
    const commonSubstring = longestCommonSubUrlstring(targetUrl, item.url);
    if (commonSubstring.length > maxCommonLength) {
      maxCommonLength = commonSubstring.length;
      bestMatch = item;
    }
  });

  return bestMatch;
}
